import React from "react";
import Lottie from "lottie-react";
import * as loader from "../../assets/loaders/loader.json";
import * as loader4 from "../../assets/loaders/loader4.json";
import * as loader3 from "../../assets/loaders/loader3.json";

export const Loader = ({ height = "400px", width = "400px", containerHeight = "100vh" }) => {
  return (
    <div style={{ width: "100%", height: { containerHeight } }}>
      <Lottie 
        animationData={loader}
        loop
        autoplay
        style={{ height: height, width: width }}
      />
    </div>
  );
};

export const Loader2 = () => {
  return (
    <div style={{ width: "100px", height: "50px" }}>
      <Lottie 
        animationData={loader4}
        loop
        autoplay
        style={{ height: 50, width: 100 }}
      />
    </div>
  );
};

export const Loader3 = () => {
  return (
    <div style={{ width: "100px", height: "50px" }}>
      <Lottie 
        animationData={loader3}
        loop
        autoplay
        style={{ height: 50, width: 100 }}
      />
    </div>
  );
};